/*
    Метрика: определяем, что пользователь увидел картинку
*/

import { throttle } from './Util';

let imd;



class ImagesMetricDetect {
    constructor(pageData) {
        /*
            В момент загрузки страницы существует два контейнера
            data-barba="container", поэтому определяем нужный нам
            сначала по неймспейсу (на всякий случай), а потом второй
            из них (т.к. может быть два одинаковых, напр. "category")
        */
        const namespace = pageData.next.namespace;
        const $containers = App.H.find(`[data-barba-namespace="${namespace}"]`);
        this.$container = $containers.length > 1 ? $containers.eq(1) : $containers.eq(0);

        // Теперь находим нужные картинки
        this.$images = this.$container.find('.js-project-card-img');

        this.init();
    }



    init() {
        App.W.off('scroll.imgmetric');

        if (this.$images.length === 0) { return; }


        /*
            Определяем, что пользователь увидел картинку не менее,
            чем на 33% сверху или снизу
        */

        this.$images.removeClass('_seen');

        function update() {
            const vh = App.W.height();
            const scrollTop = App.H.scrollTop();


            this.$images.each(function () {
                const $img = $(this);

                if ($img.is('._seen')) {
                    return;
                }

                const top = $img.offset().top;
                const height = $img.innerHeight();

                /*
                    Картинка может быть как ниже вьюпорта,
                    так и выше, поэтому проверяем с двух сторон
                */
                if ((top < scrollTop + vh - height * 0.3) &&
                    top + height * 0.7 > scrollTop) {

                    App.D.trigger('ga:portfolio:seen', $img);

                    // Повторно не проверяем
                    $img.addClass('_seen');
                }
            });
        }



        // Проверяем сразу при заходе на страницу
        update.call(this);

        // И ещё раз, если гугл-аналитика загрузилась позже
        App.D.on('ga:ready', () => {
            this.$images.removeClass('_seen');
            update.call(this);
        });

        // Привязываем к скроллу
        App.W.on('scroll.imgmetric', throttle(update.bind(this), 300));
    }



    destroy() {
        App.W.off('scroll.imgmetric');
        imd = false;
    }
}



App.W.on('barba:afterEnter', (event, data) => {
    if (data.next.namespace == 'category') {
        imd = new ImagesMetricDetect(data);
    }
});


App.W.on('barba:leave', () => {
    try {
        imd.destroy();
    } catch (error) { }
});



// WEBPACK FOOTER //
// ./_src/js/modules/ImagesMetricDetect.js